<fieldset>
  <div class="fixed-section">

    <section class="titleBarBg fixed-top" style="z-index: 10001;">
      <div class="container-fluid">
        <div class="row mar-7px">
          <div class="w-3">
            <img src="assets/images/sale_plan.svg" class="pageIcon" alt="">
          </div>
          <div class="w-97">
            <div class="pageHeadingBar">
              <div class="row">
                <div class="col-md-6 align-self-center">
                  <h6 class="pageHeadingText mb-0 text-uppercase">{{projectTitleDisplay}}</h6>
                </div>

                <div class="col-md-3 align-self-center">
                  <div class="d-flex">
                    <div class="nav-item dropdown">
                      <div class="button-container d-flex">
                        <div #saveDiv class="me-1 position-relative  actionButton align-self-center pointerCursor"
                          (click)="saveSalesplan()">
                          <img src="assets/images/save_icon.svg" class="saveImg me-2" alt="" title="Save">
                          <span class="statusValue pe-2">SAVE</span>
                        </div>
                        <div class="me-1 nav-item dropdown actionButton" *ngIf="salesplanId > 0">
                          <a class="nav-link dropdown-toggle urserName pointerCursor" href="#" role="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <img src="assets/images/clone_wt.png" class="saveImg me-2" alt="" title="Clone">
                            <span class="statusValue pe-2">CLONE</span>
                          </a>

                          <ul class="dropdown-menu customMargindrp w-300" style="margin: 8px;">
                            <div class="row mb-12px">
                              <div class="col-md-4 pe-0 align-self-center">
                                <label for="" class="required">EVENT TITLE</label>
                              </div>
                              <div class="col-md-8 ps-0">
                                <input type="text" class="form-control" maxlength="500"
                                  [(ngModel)]="clonedProjectTitle">
                              </div>
                            </div>
                            <div class="row">
                              <div class="offset-md-5 col-md-7 ps-0">
                                <button class="btn progressBtn w-100" role="button" (click)="cloneSalesPlan()">
                                  CLONE
                                </button>
                              </div>
                            </div>
                          </ul>
                        </div>
                        <div #CancelDiv class="me-1 position-relative actionButton align-self-center"
                          (click)="cancelProject()">
                          <img src="assets/images/closered_circle 1.png" class="saveImg me-2" alt="" title="Cancel">
                          <span class="statusValue pe-2">DELETE</span>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-md-3 align-self-center">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="mt-131 fixed-top fixedHeaderBg">
      <div class="container-fluid px-2">
        <div class="row">
          <div class="col-md-12">
            <div class="card border-0 stepsBars">
              <div class="card-body pb-1">
                <div class="main mx-2 pb-1 ms-0">
                  <div class="progressbar ml-34">
                    <ul>
                      <li>
                        <p class="label">INITIATED</p>
                      </li>
                      <li>
                        <p class="label">APPROVAL</p>
                      </li>
                      <!-- <li>
                      <p class="label">PWR LINKED</p>
                    </li> -->

                      <!-- <li>
                        <p class="label">COMPLETED</p>
                    </li> -->

                    </ul>
                  </div>

                  <div class="progressbar mb-2 ml-34">
                    <ul>
                      <li>
                        <div class="border-div">
                          <div class="step first" [ngClass]="displayBubbleStatus.Initiated_step">
                            <img src="assets/images/initiated_icon.svg" alt="">
                          </div>
                        </div>

                      </li>
                      <li>
                        <div class="border-div">
                          <div class="step second" [ngClass]="displayBubbleStatus.Approval_step">
                            <img src="assets/images/approve_icon.svg" alt="">
                            <!-- <img src="assets/images/approve_icon_white.png" alt=""> -->
                          </div>
                        </div>
                      </li>
                      <!-- <li>
                      <div class="border-div">
                        <div class="step third" [ngClass]="displayBubbleStatus.PWRLinked_step">
                          <img src="assets/images/link_icon.svg" alt="">
                        </div>
                      </div>
                    </li> -->

                      <!-- <li>
                        <div class="border-div">
                        <div class="step seventh" [ngClass]="completedStatusClass">
                            <img src="assets/images/completed_icon.svg" alt="">
                        </div>
                        </div>
                    </li> -->

                    </ul>
                  </div>

                  <div class="d-flex w-100 mt-3 ">

                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-2 pe-0 align-self-center">
                          <label class="required">CATEGORY</label>
                        </div>
                        <div class="col-md-4">
                          <!-- <select class="form-select ms-2" aria-label="Default select example" [disabled]="disableAfterReview" [(ngModel)]="selectedCategory" (change)="onSelectedCategory()">
                          <option selected="" value="0">Select Category</option>
                          <option *ngFor="let catg of categoryList;" [value]="catg.categoryID">
                            {{catg.categoryName}}
                          </option>
                        </select> -->

                          <!-- <p-multiSelect [options]="categoryList" [disabled]="disableAfterReview || disableAll"
                            [(ngModel)]="selectedCategories" name="category" [showHeader]="true" [filter]="true"
                            placeholder="Select Category" (ngModelChange)="onSelectedCategory($event)"></p-multiSelect> -->

                          <p-multiSelect [options]="categoryList" [disabled]="disableAfterReview || disableAll"
                            [(ngModel)]="selectedCategories" name="category" [showHeader]="true" [filter]="true"
                            placeholder="Select Category" (ngModelChange)="onSelectedCategory($event)">

                            <ng-template pTemplate="header">
                              <div class="custom-multiselect-header">
                                <span>SELECT ALL</span>
                                <p-checkbox [ngModel]="allSelected" name="chkSelectAll" ngDefaultControl
                                  (onChange)="toggleSelectAll($event)"></p-checkbox>
                              </div>
                            </ng-template>
                          </p-multiSelect>

                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 text-end align-self-center">
                      <div class="row">
                        <div class="col-md-12 pe-0 d-flex w-100 justify-content-end">
                          <label class="me-2">INITIATED BY</label>
                          <p class="font-13 mb-0">{{userDisplayName}}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="menuSec mt-1">
                    <nav class="navbar navbar-expand-lg bg-white shadow-none py-0 mb-2 ms-0 border-0">

                      <div class="collapse navbar-collapse" id="navbarNav">
                        <ul class="navbar-nav mr-auto subnavLink justify-content-start">
                          <li class="nav-item me-3">
                            <a class="nav-link active" href="#generalInfo" [class.active]="activeTab === 'generalInfo'">
                              GENERAL INFORMATION
                            </a>
                          </li>

                          <li class="nav-item me-3">
                            <a class="nav-link" href="#images" [class.active]="activeTab === 'images'">
                              IMAGES
                            </a>
                          </li>

                          <li class="nav-item  me-3">
                            <a class="nav-link" href="#productInfo" [class.active]="activeTab === 'productInfo'">
                              PRODUCTS
                            </a>
                          </li>


                          <li class="nav-item">
                            <a class="nav-link" href="#approvals" [class.active]="activeTab === 'approvals'">
                              APPROVAL
                            </a>
                          </li>

                        </ul>
                      </div>

                    </nav>
                  </div>

                </div>


              </div>
            </div>


          </div>
        </div>
      </div>
    </section>
  </div>

  <div class="middleContent">




    <section class="mt-385px" id="generalInfo">
      <div class="container-fluid px-2">
        <div class="card border-0" style="border-radius: 0px 0px 5px 5px;">
          <div class="card-body pb-1 pt-3">
            <div class="row border-bottom">
              <div class="col-md-10 border-right-solid">
                <div class="row">
                  <div class="col-md-6 pe-50px border-right-solid pb-4"
                    *ngIf="((salesplanId != 0 && headerId != 0) || salesplanId == 0)">
                    <ginfo-salesplan-details [selectedGenInfoSpProject]="salesplanModel.generalInfo.salesplanDetails"
                      [enablePWR]="enablePWR" [disableAfterReview]="disableAll">
                    </ginfo-salesplan-details>

                  </div>
                  <div class="col-md-6 ps-50px pe-50px">
                    <fieldset [disabled]="disableAll">
                      <app-common-store-list [vendorId]="vendorId" [refType]="refType" [purpose]="purposeStore"
                        [selectedFile]="salesplanModel.generalInfo.storeList"
                        [selStoreDetails]="salesplanModel.generalInfo" [disableAfterReview]="disableAfterReview"
                        (emitValueChanged)="onFileChanged($event);" (storeFileSelected)="onStoreFileChanged($event);"
                        [selectedCategoryList]="selectedCategories" [storesByStates]="selectedStoresByStates"
                        [identifiedStores]="selectedIdentifiedStoreNumbers"
                        (notifyIsoAdmin)="onNotifyIsoAdmin($event);">
                      </app-common-store-list>
                    </fieldset>
                  </div>
                </div>

              </div>
              <!-- <div class="col-md-3 ps-50px" *ngIf="((salesplanId != 0 && headerId != 0) || salesplanId == 0)"> -->
              <div class="col-md-2 ps-50px">
                <ginfo-salesplan-keydates [keyDatesInfo]="salesplanModel.generalInfo.keyDates" [isSRETeam]="isSRETeam"
                  [projectApproval]="salesplanModel.projectApproval!" [enablePWR]="enablePWR"
                  [disableAfterReview]="disableAll" (emitValueChanged)="onKeyDatesChanged($event);">
                </ginfo-salesplan-keydates>
              </div>
            </div>

            <div class="row border-bottom" id="images">
              <div class="col-md-8 border-right-solid pe-50px pb-37px pt-2">
                <app-imageupload [salesplanImages]="salesplanModel.images" [disableAfterReview]="disableAll"
                  (emitValueChanged)="onImagesChanged($event)">
                </app-imageupload>
              </div>
              <div class="col-md-4 ps-50px pt-4">
                <div class="row mt-2">
                  <div class="col-md-6">
                    <label for="">LOGO <span style="text-transform: none;">(Maximum 3 Logos are allowed)</span></label>
                  </div>
                  <div class="col-md-6">
                    <!-- <div class="upload-btn-wrapper d-block text-end" [ngClass]="{'disableLink': disableAll}">
                      <a id="btnSubmit" class="button" style="text-decoration: underline;">Click here to select logo</a>
                     
                      <input multiple accept="image/png, image/gif, image/jpeg" type="file" name="myfile" type="file"
                        (change)="multiFileEvent($event)">

                    </div> -->
                  </div>
                </div>
                <!-- <textarea class="form-control h-105 mb-3" spellcheck="false" maxlength="200" [(ngModel)]="salesplanModel.generalInfo.salesplanDetails.logo"></textarea> -->

                <div class="row mt-2">
                  <div class="col-md-3 pe-0 align-self-center">
                    <div class="upload-btn-wrapper d-block" [ngClass]="{'disableLink': disableAll}">
                      <a id="btnSubmit" class="button" style="text-decoration: underline;">Click here to select logo</a>
                      <!-- <button  id="btnLogo" class="button uploadBtnforimages mt-2">
                        <img src="assets/images/download_trm.png" class="buttonIcon btnupl me-2">
                        <span>CLICK HERE TO SELECT AN LOGO FILE</span>
                    </button> -->
                      <input multiple accept="image/png, image/gif, image/jpeg" type="file" name="myfile" type="file"
                        (change)="multiFileEvent($event)">
                    </div>
                  </div>
                  <div class="col-md-1 pe-0 align-self-center">
                    <label for="">(OR)</label>
                  </div>
                  <div class="col-md-6">
                    <a id="btnSubmit" class="button" style="text-decoration: underline;cursor: pointer;"
                      (click)="showLogoLibraryPopup()">Select from logo library</a>
                  </div>
                </div>
                <div class="row border mt-3 py-3 uplimgdiv">
                  <ul class="ul-alignment">
                    <li *ngFor="let item of salesplanModel.images.logoFiles;let itemIndex=index">
                      <p>
                        <a (click)="delItem(item)">
                          <i class="fas fa-window-close mr-1 redcross crossposition-imageupload"></i>
                        </a>
                      </p>
                      <a>
                        <img src="data:{{item.type}};base64,{{item.base64Bytes}}" class="img-fluid m-auto d-block"
                          style="margin-bottom:25px !important;pointer-events:auto;"
                          onError="this.src='assets/images/loader_btn.gif'" />
                      </a>
                    </li>
                  </ul>
                </div>
                <!-- <div>
              <a *ngIf="selectedLogoImageBytes!=''">
                      <img src="data:{{selectedLogoImagetype}};base64,{{selectedLogoImageBytes}}" class="img-fluid m-auto d-block" style="margin-bottom:25px !important;pointer-events:auto;"
                          />
              </a>
              </div> -->

                <label for="" class="mb-2">CALLOUTS</label>
                <textarea class="form-control h-105 mb-3" spellcheck="false" [disabled]="disableAll"
                  [(ngModel)]="salesplanModel.generalInfo.salesplanDetails.callouts"
                  (ngModelChange)="onAnyFieldValueChange($event)"></textarea>

                <label for="" class="mb-2">
                  PROVIDE SELLING POINTS FOR WHY STORE SHOULD EXECUTE THIS DISPLAY
                  <span class="text-danger">(SEE EXAMPLES)</span>
                </label>
                <textarea class="form-control h-105 mb-0" maxlength="4000" spellcheck="false" [disabled]="disableAll"
                  [(ngModel)]="salesplanModel.generalInfo.salesplanDetails.sellingPoints"
                  (ngModelChange)="onAnyFieldValueChange($event)"></textarea>
              </div>
            </div>



            <fieldset [disabled]="disableAll">
              <div class="row border-bottom mb-2 pt-2" id="productInfo">
                <div class="col-md-3">
                  <!-- <app-common-products-list [categoryId] = "categoryId" [refType] = "refType"
                        [purpose] = "purposeProducts" [selectedFile] = "salesplanModel.products"
                        (emitValueChanged)="onFileChanged($event);"
                        (productFileSelected) = "onProductFileChanged($event);"
                        (notifyParent)="onCommuncation($event)"
                        [reciveCoomunication]="reciveCoomunication">
                    </app-common-products-list> -->

                  <app-common-products-list [categoryId]="selectedCategory.toString()" [refType]="refType"
                    [selectedCategories]="selectedCategories" [isProductListChecked]="!salesplanModel.isProductManual!"
                    [purpose]="purposeProducts" [selectedFile]="salesplanModel.products"
                    [isProductReviewChecked]="salesplanModel.isProductReviewConfirmed!"
                    (emitValueChanged)="onFileChanged($event);" (productFileSelected)="onProductFileChanged($event);"
                    [disableAfterReview]="disableAll" (notifyParent)="onCommuncation($event);"
                    (notifyRButtonStatus)="onRButtonStatus($event);"
                    (notifyProductSelections)="onProductSelectionUpdate($event);"
                    (notifyReviewConfirmation)="onProductReviewConfirmation($event)"
                    [reciveCoomunication]="reciveCoomunication" [selStoreDetails]="salesplanModel.generalInfo">
                  </app-common-products-list>
                </div>
                <div class="col-md-1 text-center">
                  <h6 class="orText mt-29">OR</h6>
                </div>
                <div class="col-md-8">
                  <app-common-product-list-manual [categoryId]="selectedCategory.toString()"
                    [selectedCategories]="selectedCategories"
                    [isProductListManualChecked]="salesplanModel.isProductManual!" [disableAfterReview]="disableAll"
                    [componentUsedBy]="refType" [selectedProductRows]="salesplanModel.productsManual"
                    (updatedProductRows)="onUpdatePRoductRows($event);"
                    (notifyProductSelections)="onProductSelectionUpdate($event);"
                    (notifyParent)="onCommuncation($event);" (notifyRButtonStatus)="onRButtonStatus($event);"
                    [reciveCoomunication]="reciveCoomunication" [categoryList]="categoryList"
                    [productItems]="productItems" [orgProductsList]="orgProductsList"
                    (onChangeAddProductCategoryID)="onChangeAddProductCategoryID($event)">
                  </app-common-product-list-manual>
                  <div class="col-md-12 text-end mb-4">
                    <button class="btnReviewLog mt-2" data-bs-toggle="modal"
                      [disabled]="salesplanModel.salesplanId == 0 || !hasProductItems"
                      (click)="addItemReviewLogs()">REVIEW PRODUCT ITEM</button>
                    <div class="text-end"
                      *ngIf="salesplanModel.salesplanId > 0 && hasProductItems && productReviewedBy != ''">
                      <span class="d-inline">Reviewed By:
                        <strong>{{productReviewedBy}}</strong> On:
                        <strong>{{productReviewedDate | date:'dd-MMM-yyyy'}}</strong>
                      </span>&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
            <div class="row mb-15px pt-4" id="approvals">
              <app-common-approval [componentUsedBy]="refType" [disableAfterReview]="disableAfterReview"
                [projectId]="salesplanModel.salesplanId" [selApprovalVM]="salesplanModel.projectApproval!"
                [selProjectStatus]="salesplanModel!.projectStatus!" [projectStatusList]="salesplanModel.projectStatuses"
                [allStatusList]="salesplanModel!.projectStatusMaster!"
                (notifyBubbleStatus)="onBubbleStatusChanged($event);" [categoryid]="catgId"
                (emitKeyValueChangesAfterReviewRequest)="KeyValueChangesAfterReviewRequest($event);"
                (notifyReadyForReviewClicked)="ReadyForReview($event);">
              </app-common-approval>
            </div>
          </div>
        </div>


      </div>
    </section>

  </div>
</fieldset>
<div class="modal fade" id="logoModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdrop_fourLabel" aria-hidden="true" *ngIf="showModalPopup">
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header custommodal-header py-2">
        <h1 class="modal-title modalTitle" id="staticBackdrop_fourLabel">LOGO LIBRARY</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body pb-2">
        <div class="row">
          <div *ngFor="let image of logos; let index = index" class="col-3 customCol position-relative mb-3">
            <!-- Checkbox -->
            <div class="checkbox-container">
              <input type="checkbox" [id]="'checkbox' + index" [value]="image"
                (change)="onLogoImageSelect($event, image)" [checked]="isImageSelected(image)" />
              <label [for]="'checkbox' + index"></label>
            </div>

            <!-- Image -->
            <img [src]="'data:image/jpeg;base64,' + image.imageBase64String" class="storeImg w-100" alt="Image" />

          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn progressBtn ps-2" role="button" (click)="submitSelectedImages()">SELECT LOGOS</button>
      </div>
    </div>
  </div>
</div>